<template>
  <div class="flex right_card">
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.Receivables.Sold')}}</div>
      <div class="card_content font_bold">{{salesSummary.soldCount}}</div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.Receivables.volume')}}</div>
      <div class="card_content font_bold">
        <span>{{millionFormat(salesSummary.totalReceivableVolume) }}</span>
        <i v-if="isMillion(salesSummary.totalReceivableVolume)">m</i>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.Sales.volume')}}</div>
      <div class="card_content font_bold">
        <span>{{millionFormat(salesSummary.totalSalesVolume) }}</span>
        <i v-if="isMillion(salesSummary.totalSalesVolume)">m</i>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.seller.discountRate')}}</div>
      <div class="card_content font_bold">
        <FieldWithUnit :value="salesSummary.avgDiscountPercentage" unit="%"></FieldWithUnit>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">
        <span>{{$t('dashboard.Advanced.day')}}</span>
      </div>
      <div class="card_content font_bold">
        <FieldWithUnit :value="salesSummary.avgAdvancedDays" :unit="$t('common.day.short')"></FieldWithUnit>
      </div>
    </div>
    <div class="md-card md-card-tabs">
      <div class="md-card-header font_bold">{{$t('dashboard.effective.tip')}}</div>
      <div class="card_content font_bold">
        <FieldWithUnit :value="salesSummary.avgCostOfCapitalPercentage" unit="%"></FieldWithUnit>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {formatAsDecimal} from "@/common/format";
import FieldWithUnit from "@/views/dashboard/FieldWithUnit";

export default {
  data() {
    return {
      defaultSalesSummary: {
        soldCount: 0,
        totalReceivableVolume: "",
        totalSalesVolume: "",
        avgDiscountPercentage: null,
        avgAdvancedDays: null,
        avgCostOfCapitalPercentage: null
      },
      salesSummary: {
        ...this.defaultSalesSummary
      }
    };
  },
  components: {
    FieldWithUnit
  },
  computed: {
    ...mapGetters({ dashboardInfo: "dashboardInfo" })
  },
  watch: {
    dashboardInfo() {
      let { statisticData } = this.dashboardInfo;
      if (statisticData && statisticData.salesSummary) {
        this.salesSummary = {
          ...statisticData.salesSummary,
          soldCount: formatAsDecimal(statisticData.salesSummary.soldCount, {decimals: 0}),
          avgDiscountPercentage: formatAsDecimal(statisticData.salesSummary.avgDiscountPercentage),
          avgAdvancedDays: formatAsDecimal(statisticData.salesSummary.avgAdvancedDays, {decimals: 0}),
          avgCostOfCapitalPercentage: formatAsDecimal(statisticData.salesSummary.avgCostOfCapitalPercentage),
        };
      } else {
        this.salesSummary = this.defaultSalesSummary
      }
    }
  }
};
</script>